export const APPLE = 'Apple';
export const ANDROID_SERVICE = 'Android';
